export type ShopifyPurchaseTypeKey = 'one_time' | 'subscription' | 'both';

const payments = (limit: number) =>
  limit < 0
    ? 'number of payments not set'
    : limit === 0
      ? 'all payments'
      : limit === 1
        ? 'first payment'
        : `first ${limit} payments`;

/** Copy for which purchases a Shopify discount applies to (one-time,
 *  subscription or both) and how many subscription payments it covers. */
export const shopifyPurchaseTypeCopy = {
  label: 'Purchase type',
  hint: 'Only matters if your store sells subscriptions.',
  options: {
    one_time: 'One-time purchase',
    subscription: 'Subscription',
    both: 'Both',
  } satisfies Record<ShopifyPurchaseTypeKey, string>,
  recurringLabel: 'Recurring payments for subscriptions',
  recurring: {
    first: 'Limit discount to the first payment',
    multiple: 'Limit discount to multiple recurring payments',
    all: 'Discount applies to all recurring payments',
  },
  paymentsLabel: 'Number of payments',
  paymentsInvalid: 'Enter a whole number from 2 to 2,147,483,647.',
  invalidToast: 'Recurring payments must be 2 or more, or pick another option.',
  bxgyNote:
    'Purchase type applies to the items customers buy. The items they get are one-time purchases only.',
  bxgySummary: (purchaseType: string | undefined): string => {
    if (purchaseType === 'subscription') return 'Buys: subscriptions';
    if (purchaseType === 'both') return 'Buys: one-time and subscriptions';
    return 'One-time purchases';
  },
  summaryLabel: 'Purchase',
  summary: (purchaseType: string | undefined, limit: number): string => {
    if (purchaseType === 'subscription') return `Subscriptions, ${payments(limit)}`;
    if (purchaseType === 'both') return `One-time and subscriptions, ${payments(limit)}`;
    return 'One-time purchases';
  },
} as const;
